import React from 'react';
import './faq.css'; // Create this file for styling

function FAQPage() {
  const faqs = [
    {
      id: 1,
      question: "Are Swarna products suitable for all skin types?",
      answer:
        "Yes, our products are made with natural and gentle ingredients like aloe vera, turmeric, neem, and sandalwood, making them suitable for all skin types including sensitive, oily, and dry skin."
    },
    {
      id: 2,
      question: "Do your soaps contain any harsh chemicals or artificial fragrance?",
      answer:
        "No. All our soaps are handmade with herbal ingredients and do not contain sulfates, parabens, or artificial fragrances. We use natural essential oils for mild and soothing scents."
    },
    {
      id: 3,
      question: "Which product is best for acne-prone skin?",
      answer:
        "Our Herbal Neem Soap and Charcoal Soap are ideal for acne-prone and oily skin. They help reduce inflammation, cleanse pores, and fight bacteria naturally."
    },
    {
      id: 4,
      question: "Can I use the Ubtan Face Pack daily?",
      answer:
        "We recommend using the Ubtan Face Pack 2–3 times a week for best results. It detoxifies and brightens the skin without stripping away natural oils."
    },
    {
      id: 5,
      question: "What’s the difference between your Dry Ubtan Face Wash and Dry Face Scrub?",
      answer:
        "The Face Wash is for daily gentle cleansing, while the Face Scrub is slightly more coarse and is best used 2–3 times a week to exfoliate and remove dead skin cells."
    },
    {
      id: 6,
      question: "Is your shampoo safe for chemically treated hair?",
      answer:
        "Yes, our Herbal Shampoo is free from sulfates and parabens, making it gentle and safe for chemically treated or colored hair."
    },
    {
      id: 7,
      question: "How does your Night Cream work?",
      answer:
        "Our Night Cream hydrates and repairs your skin overnight using ingredients like aloe vera and hyaluronic acid. It reduces dark spots, uneven tone, and leaves your skin soft and supple."
    },
    {
      id: 8,
      question: "Can I apply Aloe Vera Gel on sunburned skin?",
      answer:
        "Absolutely. Our Aloe Vera Gel soothes sunburn, reduces redness, and provides instant hydration. It’s great for post-sun exposure care."
    },
    {
      id: 9,
      question: "Are your products cruelty-free?",
      answer:
        "Yes, all Swarna Herbal Products are 100% cruelty-free and not tested on animals."
    },
    {
      id: 10,
      question: "How can I place an order?",
      answer:
        "You can browse our product catalog, add items to your cart, and proceed to checkout. We support multiple payment options and deliver across India."
    }
  ];

  return (
    <div className="faq-page">
      <h1 style={{ textAlign: "center" }}>Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqs.map((faq) => (
          <div key={faq.id} className="faq-item">
            <h3 className="faq-question">{faq.question}</h3>
            <p className="faq-answer">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQPage;
